export default "__VITE_ASSET__DyvweGRL__"